export enum RsjInstructionVisibility {
  NONE,
  FULL,
  DIE,
  DIE_PAYMENTS,
  NON_RENEWAL,
}
